import React from 'react';
import notify from 'devextreme/ui/notify';
import {Timeline, TimelineEvent} from 'react-event-timeline';
import { mediaTimelineServices } from '../../services/mediaTimeline.service';
import { Button, SelectBox } from 'devextreme-react';
import{Utilities}from '../../helpers/utilities';
import { childrenServices } from '../../services/children.service';
import { userServices } from '../../services/user.service';
import { weatherServices } from '../../services/weather.service';
import DateTimeRangeContainer from 'react-advanced-datetimerange-picker'
import {FormControl} from 'react-bootstrap'
import moment from "moment"
import { config } from '../../helpers/config';

export class MediaTimelines extends React.Component {
  constructor(props) {
    super(props);
    this.treeView = null;
    this.state = {timelines:[], childrens:[], selectedChild:'', userId:localStorage.getItem('userId'), message:'', weather:'', spireDailyUsage:[], twilioMessages:[], phoneNumber:localStorage.getItem('phoneNumber')};
    this.onClick = this.onClick.bind(this);
    this.onValueChanged = this.onValueChanged.bind(this);
    var search = new URLSearchParams(this.props.location.search);
    var selectedUserId = search.get("id");
    var roleType=localStorage.getItem('roleType');

    if(selectedUserId!=null){
      this.setState({userId:selectedUserId});
      userServices.getById(selectedUserId).then(
        user=>{
          userServices.getRoleByName(user.roles[0]).then(
            role=>{
              roleType= role.roleType;
              if(roleType===2 || roleType===3 ||roleType===4){//parent, therapis, caregiver
                childrenServices.getByUserId(selectedUserId).then(
                  data=>{
                    if(data.length>0){
                      this.setState({childrens:data});
                    }
                  },
                  error=>{
                    notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                  }
                );
              }
              else if(roleType===1){//admin
                childrenServices.getAll().then(
                  data=>{
                    if(data.length>0){
                      this.setState({childrens:data});
                    }
                  },
                  error=>{
                    notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                  }
                );
              }
            },
            error=>{
              notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
            }
          );
        },
        error=>{
          notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
        }
      );
    }
    else{
      if(roleType==='2' || roleType==='3' ||roleType==='4'){//parent, therapis, caregiver
        childrenServices.getByUserId(this.state.userId).then(
          data=>{
            if(data.length>0){
              this.setState({childrens:data});
            }
          },
          error=>{
            notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
          }
        );
      }
      else if(roleType==='1'){//admin
        childrenServices.getAll().then(
          data=>{
            if(data.length>0){
              this.setState({childrens:data});
            }
          },
          error=>{
            notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
          }
        );
      }
    }
   
    let now = new Date();
    let end = moment(moment(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0))).add(1, "days");
    let start = moment(end).subtract(30, "days");
    this.state = {
        start : start,
        end : end
    }

    this.applyCallback = this.applyCallback.bind(this);
  }
  
  applyCallback(startDate, endDate){
    this.setState({
        start: startDate,
        end : endDate
      })
  }

  createTimeline(items){
    let item = [];
    let timeline=[];
    if(items){
      for (let i = 0; i < items.length ; i++) {
        var fileName = items[i].userMediaFileName;
        var fileExt=fileName.substring(fileName.length-4);
        if(config.videoExtensions.includes(fileExt)){
          item.push(
            <TimelineEvent 
              key={i}   
              title=""
              titleStyle={{fontWeight:'bold'}}
              createdAt={Utilities.printShortDate(items[i].create_Date)}
              icon={<i className="material-icons md-18">videocam</i>} 
              iconColor="#6fba1c"
            >
              <video width="400" controls>
                <source src={items[i].filePath} type="video/mp4"></source>
                Your browser does not support HTML5 video.
              </video>
            </TimelineEvent>
          );
        }
        else{
          item.push(
            <TimelineEvent 
              key={i} 
              title="" 
              titleStyle={{fontWeight:'bold'}}
              createdAt={Utilities.printShortDate(items[i].create_Date)}
              icon={<i className="material-icons md-18">camera_alt</i>} 
              iconColor="#FF8000"
            >
              <img src={items[i].filePath} alt='' width="400"></img>
            </TimelineEvent>
          );
        }
      }    
      timeline.push(<Timeline lineColor="#ddd" style={{fontSize:'16px'}}>{item}</Timeline>);
    }
    return timeline;
  }

  onClick(e) {
    this.setState({message:''});
    mediaTimelineServices.getByUserIdAndDatetimeRange(localStorage.getItem('userId'),this.state.start.format('LLL'), this.state.end.format('LLL')).then(
      data=>{
        if(data.length>0){
          this.setState({ timelines: data, message:''});
        }
        else{
          this.setState({ timelines: [], message:'There is no data to display...'});
        }
      },
      error=>{
        notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
      }
    );
  }
  onValueChanged(e) {
    this.setState({selectedChild: e.value});
    // Get weather for the seleted child
    childrenServices.getById(e.value).then(
      data=>{
        if(data){
          weatherServices.getWeatherInfo(data.zip).then(
            result=>{
              if(result && result.main!=null){
                this.setState({weather: "City:" + result.name + " | Temperature: "+ result.main.temp + " | Max: " + result.main.temp_max + " | Min: "+result.main.temp_min});
              }
            },
            error=>{
              notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
            }
          );
        }
      },
      error=>{
        notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
      }
    );
  }
  render() {
    const { timelines, childrens} = this.state;

    let now = new Date();
    let start = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0,0,0,0));
    let end = moment(start).add(1, "days").subtract(1, "seconds");
    let ranges = {
        "Today Only": [moment(start), moment(end)],
        "Yesterday Only": [moment(start).subtract(1, "days"), moment(end).subtract(1, "days")],
        "3 Days": [moment(start).subtract(3, "days"), moment(end)]
    }
    let local = {
        "format":"MM-DD-YYYY HH:mm",
        "sundayFirst" : false
    }
    let maxDate = moment(start).add(24, "hour")

    return (
      <div>
        <div style={{float:"left",paddingTop:"5px", paddingRight:"10px"}}>Children:</div>
        <div style={{float:"left", paddingRight:"20px"}}>
          <SelectBox width={200} dataSource={childrens}
            displayExpr={
              function(item){
                if(item)
                  return item.firstName + ' '+ item.lastName;
              }
            }
            valueExpr={'childrenId'}
            placeholder={'Choose children'}
            onValueChanged={this.onValueChanged}  
            //defaultValue={} 
          />
        </div>
        <div style={{float:"left",paddingTop:"5px", paddingRight:"10px"}}>Datetime range:</div>
        <div style={{width:400,float:"left", paddingRight:"10px"}}>
          <DateTimeRangeContainer 
            ranges={ranges}
            start={this.state.start}
            end={this.state.end}
            local={local}
            maxDate={maxDate}
            applyCallback={this.applyCallback}
          >    
            <FormControl
            id="formControlsTextB"
            type="text"
            label="Text"
            placeholder="Select a date and time range"
            value={this.state.start.format('LLL')+' - '+ this.state.end.format('LLL')}
            /> 
          </DateTimeRangeContainer>
        </div>
        <div style={{float:"left", paddingRight:"10px"}}>
          <Button
            key='btnView'
            width={120}
            height={30}
            text='View Timeline'
            type='default'
            stylingMode='contained'
            onClick={this.onClick}
          />
        </div>
        <br/>
        <br/>
        <span style={{color:"blue"}}>{this.state.weather}</span>
        <br/>
        <br/>
        <span style={{color:"red"}}>{this.state.message}</span>
        <br/>
        <div style={{float:"none"}}>
          {this.createTimeline(timelines)}
        </div>
      </div>  
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Pages/MediaTimelines.js